export default "__VITE_ASSET__WsdWESFn__"